import { createApi } from '@reduxjs/toolkit/query/react'
import { customBaseQuery } from './customBaseQuery'

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: customBaseQuery,
  tagTypes: ['User', 'Documents', 'Limits', 'Account'],
  endpoints: (builder) => ({
    getUserDocumentFiles: builder.query<any, void>({
      query: () => 'InternalApi/user/document/files',
      providesTags: ['Documents'],
    }),

    getUserLimits: builder.query<any, void>({
      query: () => 'InternalApi/user/limits/get',
      providesTags: ['Limits'],
    }),

    getUserRealityCheck: builder.query<any, void>({
      query: () => 'InternalApi/user/reality_check/get',
      providesTags: ['User'],
    }),

    getDocumentRequests: builder.query<any, void>({
      query: () => 'InternalApi/user/document/requests',
      providesTags: ['Documents'],
    }),

    editUserSettings: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/settings/set',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['User'],
    }),

    setSelfExclusion: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/limits/set_exclude',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Limits', 'User'],
    }),

    editRealityChecksPeriod: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/reality_check/edit',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['User'],
    }),

    checkUserAnswers: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/answer/check',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Documents'],
    }),

    uploadUserImage: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/document/upload',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Documents'],
    }),

    uploadFilesComplete: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/document/upload_complete',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Documents'],
    }),

    getUserImageUrl: builder.query<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/image/get',
        method: 'POST',
        body: params,
      }),
    }),

    acceptNewPolicy: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/accept_new_policy',
        method: 'POST',
        body: params,
      }),
    }),

    deleteUserUploadFile: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/document/delete',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Documents'],
    }),

    getTimeoutsProblemGambler: builder.query<any, void>({
      query: () => 'InternalApi/user/timeout/get',
    }),

    editTimeoutsProblemGambler: builder.mutation<any, any>({
      query: (params) => ({
        url: 'InternalApi/user/timeout/edit',
        method: 'POST',
        body: params,
      }),
    }),
  }),
})

export const {
  useGetUserDocumentFilesQuery,
  useGetUserLimitsQuery,
  useGetUserRealityCheckQuery,
  useGetDocumentRequestsQuery,
  useEditUserSettingsMutation,
  useSetSelfExclusionMutation,
  useEditRealityChecksPeriodMutation,
  useCheckUserAnswersMutation,
  useUploadUserImageMutation,
  useUploadFilesCompleteMutation,
  useGetUserImageUrlQuery,
  useAcceptNewPolicyMutation,
  useDeleteUserUploadFileMutation,
  useGetTimeoutsProblemGamblerQuery,
  useEditTimeoutsProblemGamblerMutation,
} = userApi